import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { RegionGazSignUpDto } from '../../_dto/_regiongaz/RegionGazSignUpDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiSignUpRegionGaz = async (dto: RegionGazSignUpDto) => {
  const params: IApiParams = {
    url: '/regiongaz/signUp.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
